import { render, staticRenderFns } from "./SystemPie.vue?vue&type=template&id=8018d928&scoped=true"
import script from "./SystemPie.vue?vue&type=script&lang=js"
export * from "./SystemPie.vue?vue&type=script&lang=js"
import style0 from "./SystemPie.vue?vue&type=style&index=0&id=8018d928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018d928",
  null
  
)

export default component.exports